import { render, staticRenderFns } from "./TrainerDropdown.vue?vue&type=template&id=fc4c8b22&"
import script from "./TrainerDropdown.vue?vue&type=script&lang=ts&"
export * from "./TrainerDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TrainerDropdown.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports